<div class="modal-content" *ngIf="initialized">
  <div class="modal-header d-block">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="h6 mb-0">Contact Us</h3>

      <button type="button" class="close" (click)="this.activeModal.dismiss()" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </div>
<div class="modal-body">
  <div class="col-12 mb-5">
    <div id="hubspotForm"></div>
  </div>
  <button *ngIf="submitted" type="button" class="btn btn-sm btn-primary btn-wide" data-dismiss="modal" (click)="close()">Close</button>
</div>
</div>
